import React from 'react';
import { AddButton } from '../AddButton';
import messages from '../ManageServices.messages';

const PractitionersAddButton = () => {
  return <AddButton message={messages.addBtn.practitioner} />;
};

export default PractitionersAddButton;
